'use client';
import React from 'react';
import { useRouter } from 'next/navigation';
import PropTypes from 'prop-types';
import "../../app/tools/ToolsPage.css"
import './Breadcrumb.css';
import strings from '../../config/App.json';
import { MdKeyboardArrowRight } from 'react-icons/md';
const Breadcrumb = ({ items }) => {
  const router = useRouter();

  const handleNavigate = (path) => {
    if (path) router.push(path);
  };

  return (
    <div className="custom-breadcrumb">
      <button className="home" onClick={() => handleNavigate(strings.HomePage)}>
        <img src="/images/Tools/homeIcon.svg" className="home-icon" alt="Home" width={16} height={16} />
      </button>
      <MdKeyboardArrowRight className="home-icon" />
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <React.Fragment key={item.path}>
            {isLast ? (
              <span className="item active">{item.label}</span>
            ) : (
              <>
                <span
                  className="item"
                  onClick={() => handleNavigate(item.path)}
                >
                  {item.label}
                </span>
                <MdKeyboardArrowRight className="home-icon" />
              </>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default Breadcrumb;
